import { supabase } from '@/lib/supabase';

const API_URL = import.meta.env.VITE_API_URL ?? '';

// Authenticated JSON fetch against the BuildersLab API.
// Throws with the server's error message on non-2xx responses.
export async function authFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in');
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}
